<template lang="pug">
    .socialwall.container
        | SocialWall
</template>

<script>

import _ from 'lodash'

export default {
    name: 'SocialWall',
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

</style>
